var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.event
    ? _c(
        "div",
        {
          staticClass:
            "simple-event-component outright-event-component clearfix",
          attrs: { idfoevent: _vm.event.idfoevent.toString() }
        },
        [
          _vm.isDebug
            ? _c("div", { staticClass: "debug" }, [
                _vm._v("\n    idfoevent " + _vm._s(_vm.event.idfoevent) + " "),
                _c("br"),
                _vm._v(
                  "\n    eventdisplayorder " +
                    _vm._s(_vm.event.eventdisplayorder)
                ),
                _c("br"),
                _vm._v(
                  "\n    eventrows " + _vm._s(_vm.event.eventrows) + "\n  "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.event.idfobolifestate === "O"
            ? _c(
                "div",
                { staticClass: "flex-row" },
                [
                  _c(
                    "div",
                    { staticClass: "event-info" },
                    [_c("cdu-info-head", { attrs: { event: _vm.event } })],
                    1
                  ),
                  _vm._v(" "),
                  _vm.event.idfobolifestate === "O" && _vm.event.outrightMarket
                    ? _c("outrightMarket", {
                        staticClass: "markets-container",
                        attrs: { event: _vm.event }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73fc70ea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73fc70ea","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bettingoffer/outrightEvent.vue
// module id = null
// module chunks = 